import { createState } from './signals-utils.js';

/**
 * Empty query handle for when no chat is selected
 * Uses createFlatStore to maintain reactivity even when returning an empty result
 */
export const EMPTY_QUERY = createState({
  key: 'empty-messages',
  isReady: true,
  fromCache: false,
  items: [],
  unsubscribe: () => {},
});
